import { Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';

export const PageTitle: React.FC<{ children: React.ReactNode }> = (props) => {
    const theme = useTheme();

    const isSmall = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Typography variant={isSmall ? 'h3' : 'h1'} component="h1" gutterBottom>
            {props.children}
        </Typography>
    );
};
